/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Save_P1Inputs */

const en_wc_tut_save_p1 = /** @type {(inputs: Wc_Tut_Save_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save keeps your document as .docx, so colleagues using Word can open it. Use Save As to choose .odt, .rtf, .html, .md, .tex or .txt.`)
};

/**
* | output |
* | --- |
* | "Save keeps your document as .docx, so colleagues using Word can open it. Use Save As to choose .odt, .rtf, .html, .md, .tex or .txt." |
*
* @param {Wc_Tut_Save_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_save_p1 = /** @type {((inputs?: Wc_Tut_Save_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Save_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_save_p1(inputs)
});
export { wc_tut_save_p1 as "wc.tut.save.p1" }